// extracted by mini-css-extract-plugin
export default {"wrap":"CG-z","fullWidth":"DG-z","hideOnDesktop":"EG-z","content":"FG-z","hasOpenedNav":"GG-z","crumbsList":"HG-z","dropdownsWrap":"IG-z"};